// Сколько пар вариантов в ответе стоят друг относительно друга так же, как в верном
// порядке. Только для подписи разбора: оценивает сервер (`grade_answer`) по тому же правилу.
export const orderedPairs = (
  correct: readonly string[],
  placed: readonly string[],
): { hits: number; total: number } => {
  const position = new Map(placed.map((id, index) => [id, index]));
  let hits = 0;
  let total = 0;
  correct.forEach((first, index) => {
    for (const second of correct.slice(index + 1)) {
      total += 1;
      const a = position.get(first);
      const b = position.get(second);
      if (a !== undefined && b !== undefined && a < b) {
        hits += 1;
      }
    }
  });
  return { hits, total };
};
